import { Checkbox, type CheckboxProps } from '@progress/kendo-react-inputs'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useLogEvent } from '~/hooks/useLogEvent'

import { showAllAtom } from '../atoms'

import styles from './ShowAllCheckbox.css'

export const ShowAllCheckbox = () => {
  const { t } = useTranslation()
  const [showAll, setShowAll] = useAtom(showAllAtom)

  const logEvent = useLogEvent()
  const handleChange = React.useCallback<EH<CheckboxProps, 'onChange'>>(
    (event) => {
      const showAll = event.value

      setShowAll(showAll)

      if (showAll) {
        logEvent('Show all saved tables and graphs')
      }
    },
    [logEvent, setShowAll],
  )

  return (
    <Checkbox
      checked={showAll}
      className={styles.root}
      label={t('show_all_tables_graphs')}
      onChange={handleChange}
    />
  )
}
